<div class="flex flex-col items-center justify-center flex-1 p-5">
  <p-toast></p-toast>
  <h1 class="mb-4" translate *ngIf="context === 'reset-password'">
    label.resetPassword
  </h1>
  <h1 class="mb-4" translate *ngIf="context === 'set-password'">
    label.setPassword
  </h1>
  <h1 class="mb-4" translate *ngIf="context === 'change-password'">
    label.changePassword
  </h1>

  <ng-container *ngIf="context !== 'change-password'; else changePassword"
    ><ng-container *ngIf="!isSent; else sent">
      <p-card class="w-full max-w-md">
        <form
          id="htmlResetPasswordForm"
          [action]="'/' + context"
          (submit)="submit($event)"
          [formGroup]="htmlResetPasswordForm"
        >
          <div class="mb-4">
            <p-floatlabel variant="on">
              <label for="password">{{ 'label.password' | translate }}</label>
              <input
                pInputText
                id="password"
                type="password"
                name="password"
                class="w-full"
                formControlName="password"
                autocomplete="new-password"
                [ngClass]="{
                  'ng-invalid': isInvalid('password'),
                  'ng-dirty': isInvalid('password'),
                  'ng-valid':
                    !isInvalid('password') &&
                    htmlResetPasswordForm.get('password')?.touched,
                }"
              />
            </p-floatlabel>
            <small
              *ngIf="isInvalid('password')"
              class="text-red-500 mt-1 block"
            >
              {{ 'label.passwordRequired' | translate }}
            </small>
          </div>
          <div class="mb-4">
            <p-floatlabel variant="on">
              <label for="password">{{
                'label.confirmPassword' | translate
              }}</label>
              <input
                pInputText
                id="confirmPassword"
                type="password"
                name="confirmPassword"
                class="w-full"
                formControlName="confirmPassword"
                autocomplete="new-password"
                [ngClass]="{
                  'ng-invalid': isInvalid('confirmPassword'),
                  'ng-dirty': isInvalid('confirmPassword'),
                  'ng-valid':
                    !isInvalid('confirmPassword') &&
                    htmlResetPasswordForm.get('confirmPassword')?.touched,
                }"
            /></p-floatlabel>
            <small
              *ngIf="isInvalid('confirmPassword')"
              class="text-red-500 mt-1 block"
            >
              {{ 'label.passwordRequired' | translate }}
            </small>
          </div>
          <button class="w-full mt-5" (onClick)="submit($event)" pButton>
            {{ 'label.submit' | translate }}
          </button>
        </form></p-card
      >
    </ng-container>
    <ng-template #sent>
      <p-card class="w-full max-w-md">
        <p
          *ngIf="context === 'reset-password'"
          [innerHTML]="'label.resetPasswordConfirmDescription' | translate"
        ></p>
        <p
          *ngIf="context === 'set-password'"
          [innerHTML]="'label.setPasswordConfirmDescription' | translate"
        ></p>

        <button class="w-full mt-5" routerLink="/login" pButton>
          {{ 'label.toLogin' | translate }}
        </button>
      </p-card>
    </ng-template>
  </ng-container>
  <ng-template #changePassword>
    <ng-container *ngIf="!isSent; else sent">
      <p-card class="w-full max-w-md">
        <p [innerHTML]="'label.changePasswordDescription' | translate"></p>
        <button
          class="w-full mt-5"
          (onClick)="sendChangePasswordMail()"
          pButton
        >
          {{ 'label.changePassword' | translate }}
        </button>
      </p-card>
    </ng-container>
    <ng-template #sent>
      <p-card class="w-full max-w-md">
        <p [innerHTML]="'label.changePasswordMailSent' | translate"></p>
      </p-card>
    </ng-template>
  </ng-template>
</div>
